import { getOsAppVersionHeaderValue, shouldAddOsAppVersionHeader } from 'opensolar-common'
import { ExtendedRequestInfoSafe } from '../types'

export const appVersionReqMiddleware = async (req: Request, options: ExtendedRequestInfoSafe) => {
  if (shouldAddOsAppVersionHeader(req.url) && !options.headers.has('Os-App-Version')) {
    options.headers.set('Os-App-Version', getOsAppVersionHeaderValue())
  }
}
